import React from 'react';
import type { JsonStructure, JsonStructureItem } from 'react-cmdk';
import { navigate } from '@gatsbyjs/reach-router';
import waitForElement from '~/util/waitForElement';
import Icon from '~/components/atom/Icon';

const useTasksItems = (): JsonStructure[number] => {
  const items: Array<JsonStructureItem> = [
    {
      id: 'tasks',
      children: 'Taken',
      icon: () => <Icon name="branches" color={{ group: 'secondary' }} />,
      onClick: () => {
        void navigate('/-/tasks');
      },
      showType: false,
      keywords: ['tasks'],
    },
    {
      id: 'create-task',
      children: 'Nieuwe taak',
      icon: () => <Icon name="plus" color={{ group: 'secondary' }} />,
      showType: false,
      onClick: async () => {
        void navigate('/-/tasks/');
        const createButton = await waitForElement<HTMLButtonElement>(
          '[data-testid="add-task-button"] button',
        );

        if (createButton) {
          createButton.click();
        }
      },
      keywords: ['new', 'task'],
    },
  ];

  return {
    heading: 'Taken',
    id: 'tasks',
    items: items,
  };
};

export default useTasksItems;
